export default{
	data(){
		return{
			step:0,//当前步骤
			btn_code_txt:"获取验证码",
			email:"",//邮箱
			valid_code:"",//验证码
			pwd:"",//密码
			confirm_pwd:"",//确认密码
			timer:"",
			count:60
		}
	},
	methods:{
		/*
		 * 下一步
		 */
		next(){
			//第一步验证邮箱
			if(this.step===0){
				this.getCode();
				return
			}
			this.resetPwd();
		},

		/*
		 * 重置密码
		 */
		resetPwd(){
			if(!this.valid_code){
				this.$Message.warning("请输入验证码");
				return
			}
      this.$axios.post("/client/email/password/reset",this.$qs.stringify({
        email : this.email,
        valid_code: this.valid_code
      })).then(res=>{
      	if(res.success){
          this.step = 2
        }
      })
		},
		/*
		 * 获取短信验证码
		 */
		getCode(){
			if(this.count!==60){
				return
			}
			if(!this.email){
				this.$Message.warning("请输入邮箱");
				return
			}
			this.$axios.post("/client/email/valid?email="+this.email).then(res=>{
				if(res.success){
          this.step = 1;
					this.timer=null;
					this.count=60;
					this.timer=setInterval(()=>{
						if(this.count>1){
							this.count-=1;
							this.btn_code_txt=this.count+"s";
							return;
						}
						this.btn_code_txt="获取验证码"
						this.count=60;
						clearInterval(this.timer);
					},1000)
				}
			})
		}
	},
	created(){

	},
	destroyed(){
    if(this.timer){
      clearInterval(this.timer);
    }
		this.timer=null;
	}
}



// WEBPACK FOOTER //
// ./src/pages/web/forget.password/main.js